import { AfterViewInit, Component, HostListener, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ExcelExportProperties, FilterService, GridColumnModel, GridComponent, InfiniteScrollService, PageService, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';

import { GridPersistRequests, UserRoles } from '../../shared/constants/app.constants';
import { tabsModel, RolePermissionsModel, Applications, ModuleNames } from '../../shared/models/app.model';
import { excelQueryCellInfo, getExcelDataSource, gridActionBeginForFilteringOdataV4, gridActionsForFiltering, updateFilterIcon, bindInfiniteScrollPrefetch, applyInfiniteGridTotalCount } from '../../shared/models/utils/grid-functions';
import { getCurrentDate } from '../../shared/models/utils/date-functions';
import { CommonService } from '../../shared/services/common.service';
import { ProspectFields, ProspectModel } from './model/prospect.model';
import { BusinessPartnersService } from './services/business-partners.service';
import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/services/auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { defaultProspectData } from './model/prospects-data';
import { SharedService } from 'projects/shared/src/public-api';
import { MatDialog } from '@angular/material/dialog';
import { ProspectsPopupComponent } from './prospects-popup/prospects-popup.component';
import { ActivatedRoute } from '@angular/router';


const BASE_URL = environment.masterApiURL;

@Component({
    selector: 'app-business-partners',
    templateUrl: './business-partners.component.html',
    styleUrl: './business-partners.component.scss',
    providers: [FilterService, InfiniteScrollService, PageService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessPartnersComponent implements OnInit, AfterViewInit {
  defaultProspectData: ProspectModel = defaultProspectData;

  showLoader: boolean = false;
  gridName: string = 'business-partners-grid';
  showGrid: boolean = false;
  businessPartners: DataManager;
  gridHeight: number = window.innerHeight - 210;
  public pageSettings: any = { pageSizes: [20, 50, 100, 500], pageSize: 200 };
  public infiniteScrollSettings: any = { enableCache: false, initialBlocks: 1, maxBlocks: 10 };
  showProspectsPopup: boolean = false;
  @ViewChild('columnChooser') columnChooser: any;
  // @ViewChild('gridTotal') gridTotal: any;

  bpGrid!: GridComponent;
  columns: any;
  prospectData!: ProspectModel;
  ProspectFields: typeof ProspectFields = ProspectFields;
  tab: string = tabsModel.details;
  bpPermissions: RolePermissionsModel[] = [];
  tabsModel: typeof tabsModel = tabsModel;
  searchSettings?: SearchSettingsModel;
  @ViewChild('bpGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.bpGrid = gridComponent;
      this.bpGrid.toolbar = this.setToolbar();
    }
  }

  totalRecords: number = 0;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.gridHeight = window.innerHeight - 210;
  }
  constructor(
    public commonService: CommonService,
    private bpService: BusinessPartnersService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    public dialog: MatDialog,
  ) {
    this.tab = tabsModel.details;
  }
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.columns = this.getColumns();
    this.loadPermissions();
  }
  loadPermissions() {
    this.commonService.getRolePermission("businessPartner")
      .subscribe({
        next: (res: any) => {
          this.bpPermissions = res.result;
          this.initData();
        },
        error: (err: HttpErrorResponse) => {
          this.commonService.showNotification("error", err.status + ": " + err.error.Message);
          this.showLoader = false;
        }
      });
  }

  updatePersistence(userId: string = this.commonService.getUserId(), value: any = '', appName: Applications.RimsSales | Applications.RimsService | '' = Applications.RimsSales) {
    this.commonService.savePersistence({ userId, name: this.gridName, value, appId: appName })
      .subscribe((res: any) => {
        localStorage.setItem(`grid${this.gridName}`, value);
      });
  }
  loadPage() {
    this.commonService.getPersistence(this.gridName, '', Applications.RimsSales)
      .subscribe({
        next: (res: any) => {
          if (res && res.result && res.result.length && res.result[0].value) {
            localStorage.setItem(`grid${this.gridName}`, res.result[0].value);
          } else {
            localStorage.removeItem(`grid${this.gridName}`);
          }
          this.showGrid = true;
          this.showLoader = false;
        },
        error: (err) => {
          this.showGrid = true;
          this.showLoader = false;
          this.commonService.showNotification("error", err?.error?.message);
        }
      });
  }
  initData() {
    this.showLoader = true;
    this.businessPartners = new DataManager({
      url: `${BASE_URL}odata/BusinessPartner`,
      adaptor: new ODataV4Adaptor(),
      headers: [{ "Authorization": `Bearer ${this.authService.getToken()}` }]
    });
    setTimeout(() => {
      this.loadPage();
    }, 50);

  }
  getColumns() {
    let columns: GridColumnModel[] = [
      { field: ProspectFields.bpId, headerText: ProspectFields.bpIdDesc, allowEditing: false, textAlign: 'Left', allowSorting: true, width: 120, isPrimaryKey: true, showInColumnChooser: true },
      { field: ProspectFields.lnId, headerText: ProspectFields.lnIdDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: ProspectFields.bpName, headerText: ProspectFields.bpNameDesc + "s", type: 'string', allowEditing: false, textAlign: 'Left', width: 180, visible: true, showInColumnChooser: true },
      { field: ProspectFields.bpStatus, headerText: ProspectFields.bpStatusDesc, type: 'string', allowEditing: false, filter: { type: 'Excel' }, allowSorting: true, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
      { field: ProspectFields.bpType, headerText: ProspectFields.bpTypeDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: ProspectFields.streetAddress, headerText: ProspectFields.streetAddressDesc, type: 'String', allowEditing: false, width: 180, textAlign: 'Left', visible: true, showInColumnChooser: true },
      { field: ProspectFields.city, headerText: ProspectFields.cityDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, filter: { type: 'Excel' }, showInColumnChooser: true },
      { field: ProspectFields.state, headerText: ProspectFields.stateDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, filter: { type: 'Excel' }, showInColumnChooser: true },
      { field: ProspectFields.country, headerText: "Country", filter: { type: 'Excel' }, type: 'string', allowEditing: false, width: 140, textAlign: 'Left', showInColumnChooser: true, visible: false },
      { field: ProspectFields.bpTelephone, headerText: ProspectFields.bpTelephoneDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      { field: ProspectFields.bpEmail, headerText: ProspectFields.bpEmailDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 180, visible: true, showInColumnChooser: true },
      { field: ProspectFields.zipCode, headerText: ProspectFields.zipCodeDesc, type: 'string', allowEditing: false, allowSorting: true, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
      { field: 'territoryName', headerText: 'Territory', allowEditing: false, type: 'string', allowSorting: true, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true, filter: { type: 'Excel' } },
      { field: 'districtName', headerText: 'District', allowEditing: false, type: 'string', allowSorting: true, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true, filter: { type: 'Excel' } },
      { field: 'regionName', headerText: 'Region', allowEditing: false, type: 'string', allowSorting: true, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true, filter: { type: 'Excel' } },
      { field: 'createdDate', headerText: 'Created Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 180 },
      { field: 'lastUpdatedDate', headerText: 'Last Updated Date', type: 'date', textAlign: 'Left',  format: { type: 'date', format: 'd MMM, y' }, width: 180 },
      { field: 'createdBy', headerText: 'Created By', type: 'string', allowEditing: false, width: 180, textAlign: 'Left', visible: true, showInColumnChooser: true },
      {
        field: 'Actions', headerText: 'Actions', width: 170, showInColumnChooser: false, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false, clipMode: 'Clip',
        commands: [
          { title: 'Details', buttonOption: { iconCss: `fas fa-tasks`, cssClass: 'e-flat' } },
          { title: 'Links', buttonOption: { iconCss: `fas fa-link`, cssClass: 'e-flat linked-items' } },
          { title: 'Comments', buttonOption: { iconCss: `fas fa-comment comments`, cssClass: 'e-flat comments-items' } },
          { title: 'Attachments', buttonOption: { iconCss: 'fas fa-file-upload', cssClass: 'e-flat attachments-items' } },
          { title: 'History', buttonOption: { iconCss: `fas fa-history history`, cssClass: 'e-flat history' } },
        ]
      }
    ];
    function hideFields(colFields: any[]) {
      colFields.forEach(cf => {
        columns.map(m => {
          if (m.field == cf) m.visible = false;
          return m;
        });
      })
    }
    const loggedInRole = this.commonService.getUSER()?.role;
    [UserRoles.salesRep].includes(loggedInRole) && hideFields(['territoryName','districtName','regionName']);
    [UserRoles.salesDistricMgr].includes(loggedInRole) && hideFields(['districtName','regionName']);
    [UserRoles.salesRegionalMgr].includes(loggedInRole) && hideFields(['regionName']);
    this.searchSettings = { fields: [ ...columns.map(x => x.type != 'date' && x.field) ].filter(
      f => !['Actions', ProspectFields.bpStatus, ProspectFields.bpType, ProspectFields.bpTelephone, false].includes(f)
    ) };
    console.log(this.searchSettings)
    return columns;
  }

  updateCommentColor(args) {
    if (args.data.commentColor) {
      const element = args.row.getElementsByClassName('comments-items')[0]
      if (element) {
        element.style.color = args.data.commentColor;
      }
    }
  }
  getCommaSeparatedAddressField(val: string, noComma?: boolean): string {
    if (!!val) {
      noComma ? val : val += ", ";
      return val;
    }
    return "";
  }
getStreetAddress(data: any): string {
  const houseNumber = data[ProspectFields.houseNumber]?.trim();
  const streetAddress = data[ProspectFields.streetAddress]?.trim();
  const completeAddress = [houseNumber, streetAddress].filter(Boolean).join(' ');
  return completeAddress
}
  onRowDataBound(args: any) {
    const data = args.data;
    const $row = args.row;
    this.updateCommentColor(args);

    if (data.linkColor) {
      const element = $row.getElementsByClassName('linked-items')[0]
      if (element) {
        element.style.color = data.linkColor;
      }
    }
    if (data.attachmentColor) {
      const element = $row.getElementsByClassName('attachments-items')[0]
      if (element) {
        element.style.color = data.attachmentColor;
      }
    }

    if (this.getPermission('bpMainGrid_links')?.enable) {
      $row.getElementsByClassName('linked-items')[0]?.classList.remove('disabled');
    } else {
      $row.getElementsByClassName('linked-items')[0]?.classList.add('disabled');
    }
    if (this.getPermission('bpMainGrid_comments')?.enable) {
      $row.getElementsByClassName('comments-items')[0]?.classList.remove('disabled');
    } else {
      $row.getElementsByClassName('comments-items')[0]?.classList.add('disabled');
    }
    if (this.getPermission('bpMainGrid_attachments')?.enable) {
      $row.getElementsByClassName('attachments-items')[0]?.classList.remove('disabled');
    } else {
      $row.getElementsByClassName('attachments-items')[0]?.classList.add('disabled');
    }
    if (this.getPermission('bpMainGrid_history')?.enable) {
      $row.getElementsByClassName('history')[0]?.classList.remove('disabled');
    } else {
      $row.getElementsByClassName('history')[0]?.classList.add('disabled');
    }
  }

  getPermission(ruleAction: string): RolePermissionsModel {
    return this.bpPermissions?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }

  onCommandClick(args: any, grid: GridComponent) {
    if (args.commandColumn.title === 'Comments') {
      this.sharedService.globalComments = {
        grid, module: ModuleNames.BusinessPartner, moduleId: args.rowData.soldToExtId, showComments: true
      }
    } else {
      this.showProspectsPopup = true;
      // this.showLoader = true;
      this.prospectData = args.rowData;
      if (args.commandColumn.title === 'Details') {
        this.tab = tabsModel.details;
      } else if (args.commandColumn.title === 'Links') {
        this.tab = tabsModel.links;
      } else if (args.commandColumn.title === 'History') {
        this.tab = tabsModel.history;
      } else if (args.commandColumn.title === 'Attachments') {
        this.tab = tabsModel.attachments;
      }
      this.openProspectPopup();
    }
  }

  onActionFailure(e: any) {
    this.commonService.showNotification("error", e.error.error.status + ": API Failure");
  }
  onGridActionBegin(args: any, grid?: any) {
    gridActionBeginForFilteringOdataV4(args);
    if (args.requestType === 'infiniteScroll') setTimeout(() => this.bpGrid?.hideSpinner());
  }

  onGridActionComplete(args: any, grid: any) {
    // gridActionsForFiltering(args, grid);
    updateFilterIcon(args, grid);
    applyInfiniteGridTotalCount(grid, (count) => { this.totalRecords = count; }, args.requestType, args);
    if (GridPersistRequests.includes(args.requestType)) {
      this.updatePersistence(this.commonService.getUserId(), this.bpGrid?.getPersistData());
    }
  }

  onDataBound() {
    bindInfiniteScrollPrefetch(this.bpGrid, () => this.totalRecords, 0, (count) => { this.totalRecords = count; });
  }

  setToolbar() {
    const disableAddIcon = !this.getPermission('bpMainGrid_add')?.enable ? 'disabled-grid-button' : '';
    const disableExcelExportIcon = !this.getPermission('bpMainGrid_export')?.enable ? 'disabled-grid-button' : '';
    let toolbar =  [
      { id: 'column-chooser', template: this.columnChooser, tooltipText: 'Show/Hide Columns' },
      { text: '', id: 'add-new-prospect', prefixIcon: 'fas fa-add', cssClass: `grid-add-button ${disableAddIcon}`, tooltipText: 'Create Prospect' },
      { id: 'refresh', align: 'Right', prefixIcon: 'fas fa-redo-alt', cssClass: '', tooltipText: 'Refresh' },
      'Search',
      { text: '', id: 'clear-filter', align: 'Right', prefixIcon: 'fas fa-filter', cssClass: `grid-filter-icon`, tooltipText: 'Clear all Filters' }
    ] as any[];
    // const toolbar: any[] = this.grid.toolbar;
    if (this.commonService.getUSER()?.role !== UserRoles.salesRep) {
      const indexExcelExport = toolbar.findIndex(fi => fi == 'Search');
      toolbar.splice(indexExcelExport + 1, 0, { text: '', id: 'excel-export', align: 'Right', prefixIcon: 'e-excelexport', cssClass: `grid-add-button`, tooltipText: 'Excel Export' })
    }
    if(!this.getPermission('bpMainGrid_add')?.visible) {
      const indexAddNew = toolbar.findIndex(fi => fi.id == 'add-new-prospect');
      toolbar.splice(indexAddNew , 1);
    }
    // insert total count display after search
    // const indexSearch = toolbar.findIndex(fi => fi == 'Search');
    // if (indexSearch > -1 && this.gridTotal) {
    //   toolbar.splice(indexSearch + 1, 0, { id: 'total-count', template: this.gridTotal, align: 'Right', tooltipText: 'Total Records' } as any);
    // }
    return toolbar;
  }
  onToolbarClick(args: any) {
    if (args.item.id === 'add-new-prospect') {
      this.tab = tabsModel.details;
      this.prospectData = defaultProspectData;
      this.showProspectsPopup = true;
      this.tab = tabsModel.details;
      this.openProspectPopup();
    } else if (args.item.id === 'refresh') {
      this.bpGrid.refresh();
    } else if (args.item.id === 'excel-export') {
      const dataSource = getExcelDataSource(this.bpGrid);
      let excelExportProperties: ExcelExportProperties = {
        dataSource,
        hierarchyExportMode: 'Expanded',
        theme: {
          header: { bold: true, backColor: '#eeeeee', fontSize: 15 }
        },
        fileName: `Business Partners (${getCurrentDate()}).xlsx`
      };
      this.bpGrid.excelExport(excelExportProperties);
    } else if (args.item.id === 'clear-filter') {
      this.bpGrid.clearFiltering();
      this.bpGrid.clearSorting();
      this.bpGrid.search('');
      this.updatePersistence(); // clears persistence
      // this.bpGrid.refresh();
    }
  }
  openProspectPopup() {
    const dialogRef = this.dialog.open(ProspectsPopupComponent, {
      backdropClass: 'no-backdrop',
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      data: {
        showProspectsPopup: this.showProspectsPopup,
        prospectData: this.prospectData,
        id: this.prospectData.soldToExtId,
        tab: this.tab,
        isMaximized: true,
        // isReadOnly: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.bpGrid.refresh();
    });
  }
  onGridCreated(event: any) {
    updateFilterIcon({ requestType: 'filtering' }, this.bpGrid);
    bindInfiniteScrollPrefetch(this.bpGrid, () => this.totalRecords, 0, (count) => { this.totalRecords = count; });
    this.route.queryParamMap.subscribe(params => {
      const primaryId = params.get('primaryId');
      const showComments = params.get('showComments') === 'true';
      if (primaryId && showComments) {
        this.prospectData = {
          ...defaultProspectData,
          soldToExtId: primaryId
        };
        this.showProspectsPopup = true;
        this.tab = tabsModel.details;
        this.openProspectPopup();
        setTimeout(() => {
          this.sharedService.globalComments = {
            grid: this.bpGrid,
            module: ModuleNames.BusinessPartner,
            moduleId: primaryId,
            showComments: true
          };
        }, 500);

        return;
      }
    });
  }
  onExcelQueryCellInfo(args: any) {
    excelQueryCellInfo(args);
  }
  getStatusClass(status: string) {
    return this.commonService.getStatusClass(status);
  }
  onHyperLinkClick(data: any) {
    this.prospectData = data;
    this.showProspectsPopup = true;
    this.tab = tabsModel.details;
    this.openProspectPopup();
  }

  onClose(e: any) {
    this.showLoader = false;
    this.showProspectsPopup = !e?.close;
    if (e?.reload) {
      this.tab = tabsModel.details;
      this.showLoader = true;
      this.showGrid = false;
      this.initData();
    }
  }
}
